module.exports = __webpack_public_path__ + "img/9788936456399.e39a8daa.jpg";